.popover_content {
  overflow: hidden auto;
  max-height: var(--max-height);
}

@media (width >= 768px) {
  .popover_content {
    max-height: var(--max-height-desktop);
  }
}

.popover_content::-webkit-scrollbar {
  display: none;
}

.popover_content__padding {
  padding: 24px;
}

@media (width >= 768px) {
  .popover_content__padding {
    padding: 16px;
  }
}
